import React, { useImperativeHandle, forwardRef, useRef, useState, useEffect, useContext, useMemo } from 'react';
import { Button, Empty, Tabs, message } from 'antd';
import styles from './index.module.scss'
import API from '@api/api'
import { AppContext } from '@utils/AppContext';
import { HOME_PAGE_TYPE, IMAGE_TYPE } from '@utils/CONST';
import dayjs from 'dayjs';
import InfiniteScroll from 'react-awesome-infinite-scroll';
import Utils from '@utils/utils';
import GoBack from '../goBack/goBack';

const tabItem = [
    {
        key: 'model',
        label: '服饰图',
    },
    {
        key: 'commodity',
        label: '商品图',
    }
];

const ProjectItem = (props) => {
    // props.favorite
    return (
        <div className={styles.ProjectItem}>
            <div className={`${styles.ProjectItemCover} ${props.favorite && styles.favoriteBox}`}>
                {
                    props.favorite ?
                        props.mainImage ?
                            <img src={Utils.getImgUrlWithWebp(props.mainImage?.split(',')[0], true)} /> :

                            <div className={styles.empty_img}></div> :
                        <img src={Utils.getImgUrlWithWebp(props.mainImage?.split(',')[0], true)} />
                }
                {
                    props.mainImage ?
                        <div className={styles.mask} onClick={props.onClick}>
                            <div className={styles.check_view}>查看合集</div>
                        </div> : ""
                }
            </div>
            {
                props.favorite ?
                    <>
                        <p className={styles.ProjectName}>
                            <i className={styles.favor_icon}></i>
                            <span>{props.projectName}</span>
                        </p>
                        <p className={styles.UpdatedTime}></p>
                    </> :
                    <>
                        <p className={styles.ProjectName}>{props.projectName}</p>
                        <p className={styles.UpdatedTime}>修改时间 {dayjs(props.updatedTime).format('YYYY/MM/DD HH:mm')}</p>
                    </>
            }
        </div>
    )
}

const TaskItem = (props) => {
    return (
        <div
            className={`${styles.TaskItem} ${props.selectTaskId == props.taskId && styles.actived}`}
            onDoubleClick={props.onDoubleClick}
            onClick={props.onClick}
        >
            <img src={Utils.getImgUrlWithWebp(props.results[0].image, true)} />
        </div>
    )
}

const TaskList = forwardRef((props, ref) => {
    const [taskList, setTaskList] = useState([])
    const [selected, setSelected] = useState()

    useImperativeHandle(ref, () => ({
        onSubmit
    }))

    const onSubmit = async () => {
        try {
            if (!selected) return false
            let res = await API.commonDownload({ taskId: selected })
            if (res?.code != 0) throw new Error(res?.message)
            const imgPath = res.data
            return imgPath
        } catch (err) {
            message.warning(err.message)
        }
    }

    const handleDoubleClick = async (item) => {
        const taskId = item.taskId
        try {
            let res = await API.commonDownload({ taskId: taskId })
            if (res?.code != 0) throw new Error(res?.message)
            const imgPath = res.data
            props.onDoubleClick(imgPath)
        } catch (err) {
            message.warning(err.message)
        }
    }

    useEffect(() => {
        if (props.projectId == 'favorite') {
            API.listBookmarkTaskv2({
                module: props.tabKey, // model or commodity
                member: props.member == 'team' ? null : props.member ? props.member : globalUser?.id
            }).then(res => {
                if (res.code != 0) throw new Error(res.message)
                console.log('setFavoriteList', res.data.filter(item => item.results.length > 0))
                setTaskList(res.data.filter(item => item.results.length > 0))
            })
        } else {
            API.getProjectDetailv2({
                projectId: props.projectId,
                member: props.member == 'team' ? null : props.member ? props.member : globalUser?.id
            }).then(res => {
                console.log(res)
                if (res.code != 0) throw new Error(res.message)
                const taskList = res.data.taskList.filter(item => item.status == "succeeded" && item.results.length > 0)
                setTaskList(taskList.reverse())
            })
        }
    }, [])

    const onPickTask = (item) => {
        setSelected(item.taskId)
    }

    return (
        <div className={`${styles.ListContent2} _beauty_scrollbar`}>
            {
                taskList.map(item => (
                    <TaskItem
                        selectTaskId={selected}
                        key={item.taskId}
                        {...item}
                        onDoubleClick={() => handleDoubleClick(item)}
                        onClick={() => onPickTask(item)}
                    />
                ))
            }
        </div>
    )
})

const PickFromProject = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        onSubmit
    }));

    const onSubmit = () => {
        if (!projectId) return Promise.resolve(false)
        return taskListRef.current.onSubmit()
    }

    const [tabKey, setTabKey] = useState('model')
    const taskListRef = useRef()
    const [projectId, setProjectId] = useState()
    const [projectName, setProjectName] = useState()
    const [projectList, setProjectList] = useState([])
    const pageIndexRef = useRef(1)
    const pageSizeRef = useRef(18)
    const [total, setTotal] = useState(0)
    const [hasMore, setHasMore] = useState()
    const { member } = useContext(AppContext)


    const fetchMoreData = async () => {
        console.log('==fetchMoreData==')
        // await Utils.delayFunc(500)
        pageIndexRef.current = pageIndexRef.current + 1
        API.listProjectv2({
            module: tabKey, // model or commodity
            pageIndex: pageIndexRef.current,
            pageSize: pageSizeRef.current,
            member: member == 'team' ? null : member ? member : globalUser?.id
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            const next = projectList?.concat(res.data.items)
            setProjectList(next.filter(item => item.imageType != IMAGE_TYPE.MODEL_VIDEO))
            setTotal(res.data.total)
            setHasMore(next.length < res.data.total)
            console.log('==fetchMoreData done==')
        }).catch(err => {
            message.warning(err.message)
        })
    }
    useEffect(() => {
        pageIndexRef.current = 1
        API.listProjectv2({
            module: tabKey, // model or commodity
            pageIndex: pageIndexRef.current,
            pageSize: pageSizeRef.current,
            member: member == 'team' ? null : member ? member : globalUser?.id
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            setProjectList(res.data.items.filter(item => item.imageType != IMAGE_TYPE.MODEL_VIDEO))
            setTotal(res.data.total)
            setHasMore(res.data.items.length < res.data.total)
        }).catch(err => {
            message.warning(err.message)
        })
    }, [tabKey])

    const onPickProject = (project) => {
        setProjectId(project.id)
        setProjectName(project.projectName)
    }

    const onCancelProject = () => {
        setProjectId()
        setProjectName()
    }

    const [favoriteList, setFavoriteList] = useState([])
    useEffect(() => {
        API.listBookmarkTaskv2({
            module: tabKey,
            member: member == 'team' ? null : member ? member : globalUser?.id
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            setFavoriteList(res.data.filter(item => item.results.length > 0))
        })
    }, [tabKey])
    const firstFavorite = useMemo(() => {
        return favoriteList[0]
    }, [favoriteList])

    return (
        <div className={styles.ListContainer}>
            {
                projectName ?
                    <div style={{ display: 'flex' }}><GoBack goBack={onCancelProject} /><p className={styles.Title} style={{ marginLeft: '14px' }}><span>{projectName}</span></p></div> :
                    <Tabs activeKey={tabKey} items={tabItem} onChange={(key) => setTabKey(key)} />
            }
            <div className={`${styles.ListContent} ${projectId && styles.Hidden} _beauty_scrollbar`}>
                <InfiniteScroll
                    length={projectList?.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    scrollableParent={document.querySelector(styles.ListContent)}
                    // pullDownToRefresh
                    // isRefreshing={isRefreshing}
                    // refreshFunction={reload}
                    pullDownComponent={<div style={{ height: "50px", background: "green" }}>下拉</div>}
                    releaseComponent={<div style={{ height: "50px", background: "red" }}>释放</div>}
                    refreshingComponent={<div style={{ height: "50px", background: "green" }}>加载中</div>}
                    refreshEndComponent={<div style={{ height: "50px", background: "red" }}>加载完成</div>}
                    loadingComponent={<div style={{ height: "50px", lineHeight: "50px", textAlign: 'center' }}><h4>加载中...</h4></div>}
                    endComponent={
                        (projectList?.length) ?
                            <div style={{ height: "30px", lineHeight: "30px", textAlign: 'center', fontWeight: 'normal', color: '#999' }}>
                                <span>没有更多内容了</span>
                            </div> : <div className={styles.EmptyContent}><Empty /></div>
                    }
                >
                    {
                        projectList?.length ?
                            <ProjectItem
                                key={"favorite"}
                                favorite={true}
                                mainImage={firstFavorite ? firstFavorite.results?.[0]?.image?.split(',')[0] : ""}
                                projectName="我的收藏"
                                onClick={() => onPickProject({ id: 'favorite', projectName: '我的收藏' })}
                            /> : <></>
                    }
                    {
                        projectList.map(item => (
                            <ProjectItem key={item.id} {...item} onClick={() => onPickProject(item)} />
                        ))
                    }
                </InfiniteScroll>
            </div>
            {
                !projectId ? "" :
                    <TaskList
                        ref={taskListRef}
                        tabKey={tabKey}
                        member={member}
                        projectId={projectId}
                        onDoubleClick={props.onDoubleClick}
                        showAllType={props.showAllType}
                    />
            }
        </div>
    )
})

export default PickFromProject